import { render, staticRenderFns } from "./NotificationViewer.vue?vue&type=template&id=b7e5825a&"
import script from "./NotificationViewer.vue?vue&type=script&lang=js&"
export * from "./NotificationViewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports